// econnections.data.ts
import { EConnection } from './econnections.model';

// newest first — just prepend a new entry here when a new one comes out
export const ECONNECTIONS: EConnection[] = [
//   { date: 'June 2, 2023',   htmlPath: 'assets/econnections/eCon1.html' },
//   { date: 'June 1, 2023',   htmlPath: 'assets/econnections/eCon2.html' },
//   { date: 'May 9, 2023',    htmlPath: 'assets/econnections/eCon3.html' },
//   { date: 'March 29, 2023', htmlPath: 'assets/econnections/eCon4.html' },
//   { date: 'March 15, 2023', htmlPath: 'assets/econnections/eCon5.html' },
//   { date: 'March 7, 2023',  htmlPath: 'assets/econnections/eCon6.html' },
//   { date: 'June 30, 2023',  htmlPath: 'assets/econnections/eCon7.html' },
  { date: 'January 7, 2026',  htmlPath: 'assets/econnections/eCon8.html' },
  { date: 'January 27, 2026',  htmlPath: 'assets/econnections/eCon9.html' },
  { date: 'February 10, 2026',  htmlPath: 'assets/econnections/eCon10.html' },
  { date: 'February 18, 2026',  htmlPath: 'assets/econnections/eCon11.html' },
  { date: 'February 25, 2026',  htmlPath: 'assets/econnections/eCon12.html' },
  { date: 'February 27, 2026',  htmlPath: 'assets/econnections/eCon13.html' },
  { date: 'March 9, 2026',  htmlPath: 'assets/econnections/eCon14.html' },
   {date: 'March 13, 2026',  htmlPath: 'assets/econnections/eCon15.html' },
   {date: 'March 25, 2026',  htmlPath: 'assets/econnections/eCon16.html' },
   {date: 'March 31, 2026',  htmlPath: 'assets/econnections/eCon17.html' },
      {date: 'April 7, 2026',  htmlPath: 'assets/econnections/eCon18.html' },
      {date: 'April 9, 2026',  htmlPath: 'assets/econnections/eCon19.html' },
      {date: 'April 23, 2026',  htmlPath: 'assets/econnections/eCon20.html' },
      {date: 'May 4, 2026',  htmlPath: 'assets/econnections/eCon21.html' },
      {date: 'May 27, 2026',  htmlPath: 'assets/econnections/eCon22.html' },
      {date: 'June 3, 2026',  htmlPath: 'assets/econnections/eCon24.html' },
      {date: 'June 30, 2026',  htmlPath: 'assets/econnections/eCon25.html' },
      {date: 'July 2, 2026',  htmlPath: 'assets/econnections/eCon26.html' },
      {date: 'July 17, 2026',  htmlPath: 'assets/econnections/eCon27html' },
      {date: 'August 4, 2026',  htmlPath: 'assets/econnections/eCon28.html' },
      {date: 'August 19, 2026',  htmlPath: 'assets/econnections/eCon29.html' },
      {date: 'August 26, 2026',  htmlPath: 'assets/econnections/eCon30.html' },
      {date: 'September 10, 2026',  htmlPath: 'assets/econnections/eCon31.html' },
];